const CONDITION_STATUS_VALUES = {
  NEW: '새 상품',
  USED: '중고',
  LIKE_NEW: '사용감 없음',
  LIGHTLY_USED: '사용감 적음',
  HEAVILY_USED: '사용감 많음',
  DAMAGED: '고장/파손 상품',
  UNDEFINED: '상태없음',
} as const;

export const getConditionStatus = (condition?: string) => {
  if (!condition) return null;

  return CONDITION_STATUS_VALUES?.[condition as keyof typeof CONDITION_STATUS_VALUES] ?? null;
};
